import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import clientApi from "../../api/client";
import { selectClientDebtList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getClientDebtList(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientDebtList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.clientDebtListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const debts = await clientApi.getClientDebtList(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, debts);

      dispatch(
        actions.clientDebtListFetchSuccess({
          data: debts.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.clientDebtListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getClientDebtListCount(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientDebtList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.clientDebtListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await clientApi.getClientDebtCount(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();

      dispatch(actions.clientDebtListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.clientDebtListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeClientDebtListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientDebtListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeClientDebtListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientDebtListChangePage(page));
  };
}

export function changeClientDebtListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientDebtListChangeFilter(filter));
  };
}

export function clientDebtListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectClientDebtList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.clientDebtListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.clientDebtListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
